import { useCallback, useEffect, useRef, useState } from 'react';
import { Subscription } from 'rxjs';
import { ProjectChannel, pushes, EventType, SocketData } from 'api/pushes';

export const useMultiProjectWsUpdatesInRM = <T>(
  projectChannels: ProjectChannel[],
  handler: (socketData: SocketData<T>) => void,
  [action, objectType]: EventType,
): void => {
  const handlerRef = useRef<any>();

  handlerRef.current = handler;
  const handlerProxy = useCallback((params) => {
    handlerRef.current?.(params);
  }, []);
  const [subscribedProjectIds, setSubscribedProjectIds] = useState<number[]>(
    [],
  );
  const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);
  const subscriptionsRef = useRef<Subscription[]>(subscriptions);

  subscriptionsRef.current = subscriptions;

  useEffect(() => {
    const newProjectChannels = projectChannels.filter(
      (x) => !subscribedProjectIds.includes(x[3][1]),
    );

    if (newProjectChannels.length > 0) {
      setSubscribedProjectIds(
        subscribedProjectIds.concat(newProjectChannels.map((x) => x[3][1])),
      );
      setSubscriptions(
        subscriptions.concat(
          newProjectChannels.map((channel) =>
            pushes<T>(channel, [action, objectType]).subscribe(handlerProxy),
          ),
        ),
      );
    }
  }, [
    action,
    handlerProxy,
    objectType,
    projectChannels,
    subscribedProjectIds,
    subscriptions,
  ]);

  useEffect(() => {
    return () => {
      subscriptionsRef.current.map((s) => s.unsubscribe());
    };
  }, []);
};
